jQuery(function ($) {
  const sections = $('[data-textToc]');

  $.each(sections, function () {
    const section = $(this);
    const tocContainer = section.find('[data-toc]');
    const headlines = $('#main').find('section:not(.hero):not(.pageHeader)').find('h1, h2, h3, h4, h5, h6').not('.toc-title');

    tableOfContents('#main', tocContainer, { listType : 'ol' }, headlines);
  });
});
